/* unplugin-vue-components disabled */import { render } from "./audit-logs.vue?vue&type=template&id=3a92add6&scoped=true"
import script from "./audit-logs.vue?vue&type=script&lang=js"
export * from "./audit-logs.vue?vue&type=script&lang=js"

import "./audit-logs.vue?vue&type=style&index=0&id=3a92add6&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a92add6"],['__file',"src/pages/settings/superuser/audit/audit-logs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a92add6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a92add6', __exports__)) {
    api.reload('3a92add6', __exports__)
  }
  
  module.hot.accept("./audit-logs.vue?vue&type=template&id=3a92add6&scoped=true", () => {
    api.rerender('3a92add6', render)
  })

}


export default __exports__